import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { authClient } from "@/lib/auth-client";
import { isIosApp } from "@/lib/platform";
import { t } from "@shared/i18n";

/** Affiché uniquement si Google OAuth est réellement configuré côté serveur. */
export function GoogleButton({ callbackPath = "/app" }: { callbackPath?: string }) {
  const [loading, setLoading] = useState(false);
  const caps = useQuery({
    queryKey: ["auth-capabilities"],
    queryFn: () => api<{ google: boolean }>("/api/auth-capabilities"),
    staleTime: Infinity,
  });
  // App iPhone : Google refuse la connexion dans une WebView, et l'App Store exigerait « Se connecter avec Apple » (règle 4.8).
  if (!caps.data?.google || isIosApp) return null;
  return (
    <>
      <Button
        variant="outline"
        size="lg"
        className="w-full"
        loading={loading}
        onClick={async () => {
          setLoading(true);
          await authClient.signIn.social({ provider: "google", callbackURL: `${window.location.origin}${callbackPath}`, newUserCallbackURL: `${window.location.origin}/onboarding` });
        }}
      >
        <svg viewBox="0 0 24 24" className="size-4" aria-hidden>
          <path fill="#4285F4" d="M22.6 12.2c0-.8-.1-1.5-.2-2.2H12v4.2h5.9a5 5 0 0 1-2.2 3.3v2.7h3.6c2.1-1.9 3.3-4.8 3.3-8Z" />
          <path fill="#34A853" d="M12 23c3 0 5.5-1 7.3-2.7l-3.6-2.8c-1 .7-2.2 1-3.7 1-2.9 0-5.3-1.9-6.2-4.5H2.1v2.9A11 11 0 0 0 12 23Z" />
          <path fill="#FBBC05" d="M5.8 14a6.6 6.6 0 0 1 0-4.2V7H2.1a11 11 0 0 0 0 9.9L5.8 14Z" />
          <path fill="#EA4335" d="M12 5.4c1.6 0 3 .6 4.2 1.6l3.1-3.1A11 11 0 0 0 2.1 7l3.7 2.8C6.7 7.3 9.1 5.4 12 5.4Z" />
        </svg>
        {t("Continuer avec Google")}
      </Button>
      <div className="flex items-center gap-3 text-[12px] text-subtle">
        <span className="h-px flex-1 bg-border" /> ou <span className="h-px flex-1 bg-border" />
      </div>
    </>
  );
}
